import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-educash")
class Educash extends HTMLElement {
  #total;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <div class="${style.educash}">
        <img
          src="//donna.sistemadulino.com.br/educash.svg"
          alt="Educash"
          loading="eager"
        />
        <span class="${style.educash__span}">
          ${this.#total ?? 0}
        </span>
      </div>
    `;
  }

  @willPaint
  async [trait.fetch]() {
    const { data } = await supabase
      .from("educash")
      .select("*")
      .eq("user_id", this.dataset.user);

    const total = data.reduce((acc, item) => {
      return acc + (item.value ? item.value : 0);
    }, 0);

    this.#total = total;

    return this;
  }
}

export default Educash;
